"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandler = void 0;
var rxjs_1 = require("rxjs");
var constants_1 = require("../../constants");
var operators_1 = require("rxjs/operators");
var utils_1 = require("../../utils");
var dom_1 = require("../../utils/dom");
var EventHandlerAdapter = /** @class */ (function () {
    function EventHandlerAdapter(location) {
        this.store = new rxjs_1.BehaviorSubject(null);
        this.conf = { listen: '', destination: '' };
        this.conf = location;
        this.main();
    }
    EventHandlerAdapter.prototype.state = function () {
        return this.store.asObservable().pipe(operators_1.filter(function (e) { return !utils_1.isNullOrUndefined(e); }), operators_1.map(function (_a) {
            var detail = _a.detail;
            return detail;
        }));
    };
    EventHandlerAdapter.prototype.main = function () {
        var _this = this;
        dom_1.atDocument().addEventListener(this.conf.listen, function (e) { return _this.store.next(e); });
    };
    EventHandlerAdapter.prototype.dispatch = function (state, action) {
        if (action === void 0) { action = ''; }
        var data = { stateApp: __assign({}, state), action: action };
        var CustomEvent = dom_1.atWindow().CustomEvent;
        var event = new CustomEvent(this.conf.destination, { detail: data });
        dom_1.atDocument().dispatchEvent(event);
    };
    EventHandlerAdapter.prototype.on = function (currentAction) {
        if (currentAction === void 0) { currentAction = ''; }
        return this.state().pipe(operators_1.filter(function (_a) {
            var action = _a.action;
            return !currentAction || currentAction === action;
        }), operators_1.map(function (_a) {
            var stateApp = _a.stateApp;
            return (__assign({}, stateApp));
        }));
    };
    // @ts-ignore
    EventHandlerAdapter.prototype.onChanges = function (fun, currentAction) {
        if (currentAction === void 0) { currentAction = ''; }
        this.state()
            .subscribe(function (_a) {
            var action = _a.action, stateApp = _a.stateApp;
            return !currentAction || currentAction === action ? fun(__assign({}, stateApp)) : null;
        });
    };
    return EventHandlerAdapter;
}());
exports.EventHandler = {
    root: function () { return new EventHandlerAdapter({ listen: constants_1.EVENT_HANDLER_ROOT, destination: constants_1.EVENT_HANDLER_CHILD }); },
    child: function () { return new EventHandlerAdapter({ listen: constants_1.EVENT_HANDLER_CHILD, destination: constants_1.EVENT_HANDLER_ROOT }); },
    custom: function (tag) { return new EventHandlerAdapter({ listen: tag, destination: tag }); },
};
